import React, {  useEffect, useState,useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container'; 
import Stack from '@mui/material/Stack'; 
import TextField from '@mui/material/TextField';  
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import "css/employeeHeader.css";
import "css/customDialog.css";
import PropTypes from 'prop-types'; 

const initialSubStore = {
  "id":"", 
  "store_id":0,
  "indexrosubstore":0,
  "code":"",
  "name":"",
  "tradename":"",
  "enabled": true, 
  "defaultsubstore": true, 
  "roadtype_id":74,
  "roadtype_namees":"",
  "roadtype_nameen":"",
  "street":"",
  "country_id":1,
  "country_namees":"",
  "country_nameen":"",
  "province_id":30,
  "province_name":"",
  "postalcode_id":6911,
  "postalcode_postalcodename":"",
  "community_id":6,
  "community_namees":"",
  "community_nameen":"",
  "phone":"",
  "email":""
};
  

const initialTypesToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": ""
}];

const initialCountriesToSelect = [{
  "id" : 1,
  "namees" : "",
  "nameen" : "",
  "enabled":true
}];

const initialProvincesToSelect = [{
  "id" : "",
  "name" : "",
  "enabled" : true,
  "country_id":1
}];

const initialPostalCodesToSelect = [{
  "id":"",
  "postalcode":"",
  "name":"",
  "postalcodename":"",
  "enabled":true,
  "province_id":30
}];

const StoreCreateOrEditSubStore = ({openEditRowSubStore,setOpenEditRowSubStore,openEditNewSubStore,setOpenEditNewSubStore,formStore,setFormStore,editRowSubStore,setEditRowSubStore,defaultStore}) => {
  const {t,i18n} = useTranslation(['listDataStores']); 
  const token = useSelector((state) => state.loginUser.token); 
  const DEFAULTROADTYPE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
  const [newSubStore,setNewSubStore]= useState(initialSubStore);
  const [errorsSubStore, setErrorsSubStore] = useState({});
  const [roadTypesToSelect,setRoadTypesToSelect]= useState(initialTypesToSelect);
  const [communityToSelect,setCommunityToSelect]= useState(initialTypesToSelect);
  const [countryToSelect,setCountryToSelect]= useState(initialCountriesToSelect);
  const [provinceToSelect,setProvinceToSelect]= useState(initialProvincesToSelect);
  const [postalCodeToSelect,setPostalCodeToSelect]= useState(initialPostalCodesToSelect); 
  const dispatch = useDispatch();

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowSubStore) {
        setNewSubStore(initialSubStore);
        setErrorsSubStore({});
        setRoadTypesToSelect(initialTypesToSelect);
        setCommunityToSelect(initialTypesToSelect);
        setCountryToSelect(initialCountriesToSelect);
        setProvinceToSelect(initialProvincesToSelect);
        setPostalCodeToSelect(initialPostalCodesToSelect); 
        setEditRowSubStore(initialSubStore);
        setOpenEditNewSubStore(false);
        setOpenEditRowSubStore(false); 
      }
    },[
      setNewSubStore,
      setErrorsSubStore,
      setRoadTypesToSelect,
      setCommunityToSelect,
      setCountryToSelect,
      setProvinceToSelect,
      setPostalCodeToSelect, 
      openEditRowSubStore, 
      setEditRowSubStore,
      setOpenEditRowSubStore, 
      setOpenEditNewSubStore]
  );

  const handleClosenewSubStore = () => {
    setNewSubStore(initialSubStore);
    setErrorsSubStore({});
    setRoadTypesToSelect(initialTypesToSelect);
    setCommunityToSelect(initialTypesToSelect);
    setCountryToSelect(initialCountriesToSelect);
    setProvinceToSelect(initialProvincesToSelect); 
    setPostalCodeToSelect(initialPostalCodesToSelect);
    setEditRowSubStore(initialSubStore);
    setOpenEditNewSubStore(false);
    setOpenEditRowSubStore(false);
    toggleDrawernewSubStore(false);
  };

  const  handleChangenewSubStore = (e) => {
    const { name, value } = e.target;
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      [name]: value,
    }));   
  };
  
  const handleBlurnewSubStore = (e) => {
    handleChangenewSubStore(e);
    setErrorsSubStore(validateFormSubStore());
  };
  
  const handleChangeSelectRoadType = (event) => {
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      roadtype_id : event.target.value
      
    }));
  };

  const handleBlurSelectRoadType = (e) => {
    handleChangeSelectRoadType(e);
    setErrorsSubStore(validateFormSubStore());
  };

  const handleChangeSelectCommunity = (event) => {
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      community_id : event.target.value
    }));
  };

  const handleBlurSelectCommunity = (e) => {
    handleChangeSelectCommunity(e);
    setErrorsSubStore(validateFormSubStore());
  };
  
  const handleChangeSelectCountry = (event) => {
    setNewSubStore(newSubStore => ({
        ...newSubStore,
        country_id: event.target.value,
        province_id:0,
        postalcode_id:0
    })); 
  };

  const handleBlurSelectCountry = (e) => {
      handleChangeSelectCountry(e);
      setErrorsSubStore(validateFormSubStore());
  };

  const handleChangeSelectProvince = (event) => {
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      province_id :event.target.value,
      postalcode_id:0
    }));
  };

  const handleBlurSelectProvince = (e) => {
    handleChangeSelectProvince(e);
    setErrorsSubStore(validateFormSubStore());
  };

  const handleChangeSelectPostalCode = (event) => {
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      postalcode_id:event.target.value
    }));
  };

  const handleBlurSelectPostalCode = (e) => {
    handleChangeSelectPostalCode(e);
    setErrorsSubStore(validateFormSubStore());
  };

  const handleChangeEnableddefaultsubstore = () => {
    setNewSubStore(newSubStore => ({
      ...newSubStore,
      defaultsubstore: !newSubStore.defaultsubstore
    }));
  };
 
    
  const toggleDrawernewSubStore  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleClosenewSubStore();
    }
  };
 
  const validateFormSubStore = () => {
    let errorsSubStore = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (newSubStore.code===""){
        errorsSubStore.code = 'Text_SubStoreCodeRequired';
    } else {
      if (regexInvalidCharacters.test(newSubStore.code)) {
        errorsSubStore.code = 'Text_TextNoValid';
      }
    }  

    if (newSubStore.name===""){
        errorsSubStore.name = 'Text_SubStore_NameRequired';
    } else {
      if (regexInvalidCharacters.test(newSubStore.name)) {
        errorsSubStore.name = 'Text_TextNoValid';
      }
    }   
     
    if (newSubStore.tradename===""){
        errorsSubStore.tradename = 'Text_SubStore_TradeNameRequired';
    } else {
      if (regexInvalidCharacters.test(newSubStore.tradename)) {
        errorsSubStore.tradename = 'Text_TextNoValid';
      }
    }   
    if (newSubStore.roadtype_id===undefined || newSubStore.roadtype_id===null ||newSubStore.roadtype_id==="" || newSubStore.roadtype_id===0 || newSubStore.roadtype_id==="0") {
      errorsSubStore.roadtype_id = 'Text_RoadTypeRequired';
    } 
    if (newSubStore.street===""){
        errorsSubStore.street = 'Text_StreetRequired';
    } else {
      if (regexInvalidCharacters.test(newSubStore.street)) {
        errorsSubStore.street = 'Text_TextNoValid';
      }
    }    
    if (regexInvalidCharacters.test(newSubStore.phone)) {
      errorsSubStore.phone = 'Text_TextNoValid';
    }
     if (regexInvalidCharacters.test(newSubStore.email)) {
      errorsSubStore.email = 'Text_TextNoValid';
    } 
    if (newSubStore.country_id===undefined || newSubStore.country_id===null ||newSubStore.country_id==="" || newSubStore.country_id===0 || newSubStore.country_id==="0") {
      errorsSubStore.country_id = 'Text_CountryRequired';
    }
    if (newSubStore.postalcode_id===undefined || newSubStore.postalcode_id===null ||newSubStore.postalcode_id==="" || newSubStore.postalcode_id===0 || newSubStore.postalcode_id==="0") {
      errorsSubStore.postalcode_id = 'Text_PostalCodeRequired';
    }
    
    if (!openEditNewSubStore){
      if (formStore.substores.find(item => {return (item.code.trim().toUpperCase()=== newSubStore.code.trim().toUpperCase()) })){
        errorsSubStore.code = 'Text_SubStore_Code_Exist';
      }
    }else{
        if (formStore.substores.find((item) => {return (item.indexrosubstore!==newSubStore.indexrosubstore && item.code.trim().toUpperCase()=== newSubStore.code.trim().toUpperCase()) })){
        errorsSubStore.code = 'Text_SubStore_Code_Exist';
      }
    }  

    if (!openEditNewSubStore){
      if (formStore.substores.find(item => {return (item.name.trim().toUpperCase()=== newSubStore.name.trim().toUpperCase()) })){
        errorsSubStore.name = 'Text_SubStore_Name_Exist';
      }
    }else{
        if (formStore.substores.find((item) => {return (item.indexrosubstore!==newSubStore.indexrosubstore && item.name.trim().toUpperCase()=== newSubStore.name.trim().toUpperCase()) })){
        errorsSubStore.name = 'Text_SubStore_Name_Exist';
      }
    }  

    if (!openEditNewSubStore){
      if (formStore.substores.find(item => {return (item.street.trim().toUpperCase()=== newSubStore.street.trim().toUpperCase()) })){
        errorsSubStore.street = 'Text_Store_Address_Exist';
      }
    }else{
      if (formStore.substores.find((item) => {return (item.indexrosubstore!==newSubStore.indexrosubstore && item.street.trim().toUpperCase()=== newSubStore.street.trim().toUpperCase()) })){
        errorsSubStore.street = 'Text_Store_Address_Exist';
      }
    }  
    return errorsSubStore;
  };

  const handleSubmitnewSubStore = () => {  
    setErrorsSubStore(validateFormSubStore());
    let errorsCheckSubStore=validateFormSubStore();
    if ((Object.keys(errorsCheckSubStore).length === 0) 
          && newSubStore.roadtype_id!==undefined && newSubStore.roadtype_id!==null 
          && newSubStore.roadtype_id!=='' && newSubStore.roadtype_id!=='0' && newSubStore.roadtype_id!==0 
          && newSubStore.street!==""
          && newSubStore.code!=="" 
          && newSubStore.name!=="" 
          && newSubStore.tradename!=="" 
          && newSubStore.country_id!==undefined && newSubStore.country_id!==null 
          && newSubStore.country_id!=='' && newSubStore.country_id!=='0' && newSubStore.country_id!==0 
          && newSubStore.postalcode_id!==undefined && newSubStore.postalcode_id!==null 
          && newSubStore.postalcode_id!=='' && newSubStore.postalcode_id!=='0' && newSubStore.postalcode_id!==0 
      ) {
      let defaultsubstoreFound=newSubStore.defaultsubstore; 
      if(newSubStore.community_id===undefined || newSubStore.community_id===null || newSubStore.community_id===""|| 
         newSubStore.community_id==="0" || newSubStore.community_id===0){
          newSubStore.community_id= Number(DEFAULTCOMMUNITY);
      }
      if(newSubStore.province_id===undefined || newSubStore.province_id===null || newSubStore.province_id===""|| 
        newSubStore.province_id==="0" || newSubStore.province_id===0){
         newSubStore.province_id= Number(DEFAULTPROVINCE);
      } 
      let communityFound = communityToSelect.find( item => item.id === Number(newSubStore.community_id));
      let provinceFound = provinceToSelect.find( item => item.id === Number(newSubStore.province_id));
      let countryFound = countryToSelect.find( item => item.id === Number(newSubStore.country_id));
      let roadTypeFound = roadTypesToSelect.find( item => item.id === Number(newSubStore.roadtype_id));
      let postalcodeFound = postalCodeToSelect.find( item => item.id === Number(newSubStore.postalcode_id));
      
      if (newSubStore.length<=1){
        defaultsubstoreFound=true; 
      }

      if (roadTypeFound!==undefined && postalcodeFound!==undefined) {
        let subStoreToAdd={
          "id":newSubStore.id,
          "store_id":newSubStore.store_id,
          "indexrosubstore":openEditNewSubStore?newSubStore.indexrosubstore:formStore.substores.length>0?formStore.substores[formStore.substores.length-1].indexrosubstore+1:1,
          "code":newSubStore.code,
          "name":newSubStore.name,
          "tradename":newSubStore.tradename,
          "enabled": true, 
          "defaultsubstore": defaultsubstoreFound,
          "roadtype_id": roadTypeFound.id,
          "roadtype_namees": roadTypeFound.namees,
          "roadtype_nameen": roadTypeFound.nameen,
          "street":newSubStore.street,
          "country_id": countryFound.id,
          "country_namees": countryFound.namees,
          "country_nameen": countryFound.nameen,
          "province_id": provinceFound.id,
          "province_name": provinceFound.name, 
          "postalcode_id":postalcodeFound.id,
          "postalcode_postalcodename":postalcodeFound.postalcodename,
          "community_id":communityFound.id,
          "community_namees":communityFound.namees,
          "community_nameen":communityFound.nameen,
          "phone":newSubStore.phone,
          "email":newSubStore.email
        }
        if (subStoreToAdd.defaultsubstore){
          formStore.substores.map((item)=>{
            return item.defaultsubstore=false  
          })
          setFormStore(formStore => ({
            ...formStore,
          }))
        }  
        if (!openEditNewSubStore){
          formStore.substores.push(subStoreToAdd);
        }else{
          let idx=formStore.substores.findIndex(((item) => item.indexrosubstore === newSubStore.indexrosubstore ));
          formStore.substores[idx]=subStoreToAdd
        }
        setFormStore(formStore => ({
          ...formStore,
        }))
      }
      handleClosenewSubStore();
    }else{
      if (errorsCheckSubStore.code) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.code)));
      } else if (errorsCheckSubStore.name) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.name)));
      } else if (errorsCheckSubStore.tradename) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.tradename)));
      } else if (errorsCheckSubStore.roadtype_id) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.roadtype_id)));
      } else if (errorsCheckSubStore.street) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.street)));
      } else if (errorsCheckSubStore.postalcode_id) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.postalcode_id)));
      } else if (errorsCheckSubStore.phone) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.phone)));
      } else if (errorsCheckSubStore.email) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.email)));
      } else if (errorsCheckSubStore.substores) {
        dispatch(warningErrorAction(t(errorsCheckSubStore.substores)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }  
    }  
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    const fetchDataRoadType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setRoadTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCommunity = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynamees`, token)
        : await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCommunityToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCountry = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `country/simplecountriesbynamees`, token)
          : await helpHttp().get(ENDPOINT, `country/simplecountriesbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCountryToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
 
    fetchDataRoadType();
    fetchDataCommunity();
    fetchDataCountry(); 

    return () => { isMounted = false; };

  }, [t, token, dispatch, i18n.language, openEditRowSubStore, openEditNewSubStore]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchDataProvince = async () => {
      try {
        const getData = newSubStore.country_id!==""
        ? await helpHttp().get2(ENDPOINT, `province/simpleprovincesbycountrybyname/`, token,newSubStore.country_id)
        : await  helpHttp().get2(ENDPOINT,`province/simpleprovincesbycountrybyname/`,token,"null");
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setProvinceToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
   
    fetchDataProvince();
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,openEditRowSubStore,newSubStore.country_id]);

  useEffect(() => {
    let isMounted = true;
    const fetchDataPostalCode = async () => {
      try {
        const getData = newSubStore.province_id!==""
        ? await helpHttp().get2(ENDPOINT, `postalcode/simplepostalcodesbyprovincebyname/`, token,newSubStore.province_id)
        : await  helpHttp().get2(ENDPOINT,`postalcode/simplepostalcodesbycountry/`,token,newSubStore.country_id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setPostalCodeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    fetchDataPostalCode();
    return () => { isMounted = false };
    
  }, [t,token,dispatch,i18n,openEditRowSubStore,newSubStore.country_id,newSubStore.province_id]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchDataPostalCode = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `postalcode/getpostalcodewithprovinceandcountrybyid/`, token, editRowSubStore.postalcode_id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setNewSubStore(newSubStore => ({
            ...newSubStore,
            country_id: getData.country_id !== null ? getData.country_id : Number(DEFAULTCOUNTRY),
            province_id: getData.province_id !== null ? getData.province_id : Number(DEFAULTPROVINCE)
          }));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (openEditNewSubStore && editRowSubStore.postalcode_id !== "") {
      fetchDataPostalCode();
      setNewSubStore(newSubStore => ({
        ...newSubStore,
        id: editRowSubStore.id !== null ? editRowSubStore.id : "",
        store_id: editRowSubStore.store_id !== null ? editRowSubStore.store_id : defaultStore.id,
        indexrosubstore: editRowSubStore.indexrosubstore !== null ? editRowSubStore.indexrosubstore : "",
        defaultsubstore: editRowSubStore.defaultsubstore !== null ? editRowSubStore.defaultsubstore : false,
        enabled: editRowSubStore.enabled !== null ? editRowSubStore.enabled : true,
        code: editRowSubStore.code !== null ? editRowSubStore.code : "",
        name: editRowSubStore.name !== null ? editRowSubStore.name : "",
        tradename: editRowSubStore.tradename === null  || editRowSubStore.tradename === "" ? defaultStore.tradename: editRowSubStore.tradename, 
        roadtype_id: editRowSubStore.roadtype_id !== null ? editRowSubStore.roadtype_id : 0,
        roadtype_namees: editRowSubStore.roadtype_namees !== null ? editRowSubStore.roadtype_namees : "",
        roadtype_nameen: editRowSubStore.roadtype_nameen !== null ? editRowSubStore.roadtype_nameen : "",
        street: editRowSubStore.street !== null ? editRowSubStore.street : "",
        country_id: editRowSubStore.country_id !== null ? editRowSubStore.country_id : Number(DEFAULTCOUNTRY),
        country_namees: editRowSubStore.country_namees !== null ? editRowSubStore.country_namees : "",
        country_nameen: editRowSubStore.country_nameen !== null ? editRowSubStore.country_nameen : "",
        province_id: editRowSubStore.province_id !== null ? editRowSubStore.province_id : Number(DEFAULTPROVINCE),
        province_name: editRowSubStore.province_name !== null ? editRowSubStore.province_name : "",
        postalcode_id: editRowSubStore.postalcode_id !== null ? editRowSubStore.postalcode_id : 0,
        postalcode_postalcodename: editRowSubStore.postalcode_postalcodename !== null ? editRowSubStore.postalcode_postalcodename : "",
        community_id: editRowSubStore.community_id !== null ? editRowSubStore.community_id : Number(DEFAULTCOMMUNITY),
        community_namees: editRowSubStore.community_namees !== null ? editRowSubStore.community_namees : "",
        community_nameen: editRowSubStore.community_nameen !== null ? editRowSubStore.community_nameen : "",
        phone: editRowSubStore.phone !== null ? editRowSubStore.phone : "",
        email: editRowSubStore.email !== null ? editRowSubStore.email : "",
      }));
    } else {
      setNewSubStore(initialSubStore);
       setNewSubStore(newSubStore => ({
        ...newSubStore,
        store_id: defaultStore.id,
        enabled: true,
        tradename: defaultStore.tradename, 
        roadtype_id: Number(DEFAULTROADTYPE),
        community_id:  Number(DEFAULTCOMMUNITY),
      }));
    }
    return () => {isMounted = false; };

  }, [t, token, dispatch, editRowSubStore, openEditNewSubStore,DEFAULTROADTYPE, DEFAULTCOUNTRY, DEFAULTCOMMUNITY,DEFAULTPROVINCE,defaultStore]);
 
  return(
    <>
      {openEditRowSubStore && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawernewSubStore(false)}
            onOpen={toggleDrawernewSubStore(true)}>
             <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '700px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewSubStore?t('Text_SubStore_Edit'):t('Text_SubStore_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createGroupSection" onSubmit={handleClosenewSubStore}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_SubStore_Code').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="code"
                        name="code"
                        value={newSubStore.code}
                        label={
                          errorsSubStore.code != null
                            ? t(errorsSubStore.code)
                            : t('PlaceHolder_SubStore_Code')
                        }
                        placeholder={t('PlaceHolder_SubStore_Code')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 10 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_SubStore_Name').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="name"
                        name="name"
                        value={newSubStore.name}
                        label={
                          errorsSubStore.name != null
                            ? t(errorsSubStore.name)
                            : t('PlaceHolder_SubStore_Name')
                        }
                        placeholder={t('PlaceHolder_SubStore_Name')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_SubStore_Tradename').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="tradename"
                        name="tradename"
                        value={newSubStore.tradename}
                        label={
                          errorsSubStore.tradename != null
                            ? t(errorsSubStore.tradename)
                            : t('PlaceHolder_SubStore_Name')
                        }
                        placeholder={t('PlaceHolder_SubStore_Name')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_RoadType').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="roadtype_id"
                        name="roadtype_id"
                        value={ (newSubStore.roadtype_id === undefined || newSubStore.roadtype_id ===null || newSubStore.roadtype_id ===""
                                  || newSubStore.roadtype_id ==="0" || newSubStore.roadtype_id ===0)?"":newSubStore.roadtype_id}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType}
                        onChange={handleChangeSelectRoadType}
                        helperText={errorsSubStore.roadtype_id!=null?t(errorsSubStore.roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (newSubStore.roadtype_id === undefined || newSubStore.roadtype_id ===null || newSubStore.roadtype_id ===""
                                  || newSubStore.roadtype_id ==="0" || newSubStore.roadtype_id ===0)?"": newSubStore.roadtype_id
                        }}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      >
                        <option key={0} value=""/>
                          {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                              {i18n.language==="es"?option.namees:option.nameen}
                           </option>
                        ))}
                      </TextField>  
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Address').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="street"
                        name="street"
                        value={newSubStore.street}
                        label={
                          errorsSubStore.street != null
                            ? t(errorsSubStore.street)
                            : t('PlaceHolder_Store_Address')
                        }
                        placeholder={t('PlaceHolder_Store_Address')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 250 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Country').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="country_id"
                        name="country_id"
                        value={ (newSubStore.country_id === undefined || newSubStore.country_id ===null || newSubStore.country_id ===""
                                || newSubStore.country_id ==="0" || newSubStore.country_id ===0)?Number(DEFAULTCOUNTRY):newSubStore.country_id}
                        variant="outlined"
                        onBlur={handleBlurSelectCountry}
                        onChange={handleChangeSelectCountry}
                        helperText={errorsSubStore.country_id!=null?t(errorsSubStore.country_id):""}
                        select
                        SelectProps={{
                          native: true,
                          value: (newSubStore.country_id === undefined || newSubStore.country_id ===null || newSubStore.country_id ===""
                              || newSubStore.country_id ==="0" || newSubStore.country_id ===0)?Number(DEFAULTCOUNTRY): newSubStore.country_id
                        }}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      >
                        {countryToSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                              {i18n.language==="es"?option.namees:option.nameen}
                          </option>
                        ))}
                      </TextField>  
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Province').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      {provinceToSelect.length===0?
                        <label className="text-danger">{t('Text_ProvinceNotExist')}</label>:
                          
                        <TextField
                          id="province_id"
                          name="province_id"
                          value={ (newSubStore.province_id === undefined || newSubStore.province_id ===null || newSubStore.province_id ===""
                                  || newSubStore.province_id ==="0" || newSubStore.province_id ===0)?Number(DEFAULTPROVINCE):newSubStore.province_id}
                          variant="outlined"
                          onBlur={handleBlurSelectProvince}
                          onChange={handleChangeSelectProvince}
                          helperText={errorsSubStore.province_id!=null?t(errorsSubStore.province_id):""}
                          select
                          SelectProps={{
                              native: true,
                              value: (newSubStore.province_id === undefined || newSubStore.province_id ===null || newSubStore.province_id ===""
                                  || newSubStore.province_id ==="0" || newSubStore.province_id ===0)?Number(DEFAULTPROVINCE): newSubStore.province_id
                          }}
                          fullWidth
                          inputProps={{ maxLength: 100 }}
                          className="formsubstore-input"
                        >
                          {provinceToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </TextField>  
                      }
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_PostalCode').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      {postalCodeToSelect.length===0?
                        <label className="text-danger">{t('Text_PostalCodeNotExist')}</label>:
                        <TextField
                          id="postalcode_id"
                          name="postalcode_id"
                          value={ (newSubStore.postalcode_id === undefined || newSubStore.postalcode_id ===null || newSubStore.postalcode_id ===""
                                || newSubStore.postalcode_id ==="0" || newSubStore.postalcode_id ===0)?"":newSubStore.postalcode_id}
                          variant="outlined"
                          onBlur={handleBlurSelectPostalCode}
                          onChange={handleChangeSelectPostalCode}
                          helperText={errorsSubStore.postalcode_id!=null?t(errorsSubStore.postalcode_id):""}
                          select
                          SelectProps={{
                            native: true,
                            value: (newSubStore.postalcode_id === undefined || newSubStore.postalcode_id ===null || newSubStore.postalcode_id ===""
                                  || newSubStore.postalcode_id ==="0" || newSubStore.postalcode_id ===0)?"": newSubStore.postalcode_id
                          }}
                          fullWidth
                          inputProps={{ maxLength: 100 }}
                          className="formsubstore-input"
                        >
                          <option key={0} value=""/>
                            {postalCodeToSelect.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.postalcodename}
                              </option>
                            ))}
                        </TextField>  
                      }
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Community').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="community_id"
                        name="community_id"
                        value={ (newSubStore.community_id === undefined || newSubStore.community_id ===null || newSubStore.community_id ===""
                              || newSubStore.community_id ==="0" || newSubStore.community_id ===0)?Number(DEFAULTCOMMUNITY):newSubStore.community_id}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity}
                        onChange={handleChangeSelectCommunity}
                        helperText={errorsSubStore.community_id!=null?t(errorsSubStore.community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (newSubStore.community_id === undefined || newSubStore.community_id ===null || newSubStore.community_id ===""
                                || newSubStore.community_id ==="0" || newSubStore.community_id ===0)?Number(DEFAULTCOMMUNITY): newSubStore.community_id
                        }}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      >
                        {communityToSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                            {i18n.language==="es"?option.namees:option.nameen}
                          </option>
                        ))}
                      </TextField>  
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Phone').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="phone"
                        name="phone"
                        value={newSubStore.phone}
                        label={
                          errorsSubStore.phone != null
                            ? t(errorsSubStore.phone)
                            : t('PlaceHolder_SubStore_phones')
                        }
                        placeholder={t('PlaceHolder_SubStore_phones')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_Email').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <TextField
                        id="email"
                        name="email"
                        value={newSubStore.email}
                        label={
                          errorsSubStore.email != null
                            ? t(errorsSubStore.email)
                            : t('PlaceHolder_SubStore_Email')
                        }
                        placeholder={t('PlaceHolder_SubStore_Email')}
                        variant="standard"
                        onBlur={handleBlurnewSubStore}
                        onChange={handleChangenewSubStore}
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        className="formsubstore-input"
                      />
                    </Stack>
                    <br/>
                    <Stack className="formsubstore-row">
                      <span className="formsubstore-label">
                        {t('Text_SubStore_IsDefault').toUpperCase()} :
                      </span> 
                      &nbsp;&nbsp;
                      <Checkbox  
                        checked={newSubStore.defaultsubstore} 
                        onChange={handleChangeEnableddefaultsubstore} 
                        sx={{
                          '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                      />  
                    </Stack>
                    <hr className="sidebar-divider d-none d-md-block" />
                    <div className="formdi-pending-action-group">
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitnewSubStore}>
                        {openEditNewSubStore?t('Button_Update'):t('Button_Create')}
                      </button> 
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleClosenewSubStore}>
                        {t('Button_Cancel')}
                      </button>
                    </div>  
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

StoreCreateOrEditSubStore.propTypes = {

  openEditRowSubStore: PropTypes.bool.isRequired,
  setOpenEditRowSubStore: PropTypes.func.isRequired,
  openEditNewSubStore: PropTypes.bool.isRequired,
  setOpenEditNewSubStore: PropTypes.func.isRequired,
  formStore: PropTypes.object.isRequired,
  setFormStore: PropTypes.func.isRequired, 
  setEditRowSubStore: PropTypes.func.isRequired
};

export default StoreCreateOrEditSubStore;